import AppraisalConfig from "@/views/configs/appraisal/index.vue";

export default [
  {
    path: "modelo-laudos",
    name: "Modelos de laudos",
    component: AppraisalConfig,
  },
];
